import JsZip from "jszip";
import JSZipUtils from 'jszip-utils';
import {saveAs} from 'file-saver';

export const downloadAsZip = async (files, {fileName}) => {
    const zip = new JsZip();

    await Promise.all(files.map(async ({url, filePath, getFilePath}) => {
        const binary = await urlToPromise(url);
        // @ts-ignore
        const finalFileName = getFilePath ? getFilePath(binary, {isExisted: (filePath) => zip.file(filePath)}) : filePath;
        zip.file(finalFileName, binary, { binary: true });
    }));

    const content = await zip.generateAsync({type:"blob"});

    await saveAs(content, fileName);
};

const urlToPromise = (url) => {
    return new Promise((resolve, reject) => {
        JSZipUtils.getBinaryContent(url, (err, data) => {
            if (err) reject(err)
            else resolve(data)
        })
    });
}

